/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { ButtonGroup } from "reactstrap";
import LayoutFormButton from "./LayoutFormButton";

const LayoutButtonGroupForm = ({options, config, disabled = false, unique = true, onContentChange}) => {
  return (
    <div className="d-flex justify-content-center">
      <ButtonGroup className="fill-container">
        {options.map((option, index) => {
          const { id, name, icon } = option;
          let outline, clickHandler;

          if (unique) {
            // unique button group can only have one selected (config is string)
            outline = id !== config;
            clickHandler = () => onContentChange(id);
          } else {
            // non-unique button group can have any amount selected (config is json object)
            const value = config[id] ? true : false;
            outline = !value;
            clickHandler = () => onContentChange({ ...config, [id]: !value });
          } 
 
          return (
            <LayoutFormButton
              key={index}
              outline={outline}
              disabled={disabled}
              onClick={() => clickHandler()}
              icon={icon}
              text={name}
            />
          );
        })}
      </ButtonGroup>
    </div>
  );
};

export default LayoutButtonGroupForm;
